function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_245_839)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.564 13.7681C11.6471 13.6038 11.8155 13.5002 11.9995 13.5002C12.1836 13.5002 12.352 13.6038 12.435 13.7681L13.448 15.8101C13.5193 15.9521 13.6557 16.0504 13.813 16.0731L16.085 16.4011C16.2664 16.4265 16.4179 16.5523 16.476 16.7261C16.5328 16.8988 16.4858 17.0887 16.355 17.2151L14.705 18.8151C14.5925 18.9241 14.5409 19.0816 14.567 19.2361L14.956 21.4911C14.987 21.6711 14.9115 21.8529 14.762 21.9581C14.6117 22.0647 14.4144 22.0782 14.251 21.9931L12.227 20.9341C12.0847 20.8601 11.9153 20.8601 11.773 20.9341L9.74902 21.9931C9.58562 22.0782 9.3883 22.0647 9.23802 21.9581C9.08859 21.8529 9.01306 21.6711 9.04402 21.4911L9.43202 19.2361C9.45855 19.0817 9.4073 18.9242 9.29502 18.8151L7.64502 17.2151C7.51381 17.089 7.46673 16.8988 7.52402 16.7261C7.58161 16.5524 7.73278 16.4264 7.91402 16.4011L10.186 16.0731C10.3436 16.0503 10.4802 15.9522 10.552 15.8101L11.564 13.7681Z",
  stroke: "white",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6 23.25H3.75C2.92157 23.25 2.25 22.5784 2.25 21.75V12.75",
  stroke: "white",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.75 12.75V21.75C21.75 22.5784 21.0784 23.25 20.25 23.25H18",
  stroke: "white",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.148 0.75H2.852C2.50038 0.749942 2.19579 0.993864 2.119 1.337L0.75 7.5C0.75 8.74264 1.75736 9.75 3 9.75C4.24264 9.75 5.25 8.74264 5.25 7.5C5.25 8.74264 6.25736 9.75 7.5 9.75C8.74264 9.75 9.75 8.74264 9.75 7.5C9.75 8.74264 10.7574 9.75 12 9.75C13.2426 9.75 14.25 8.74264 14.25 7.5C14.25 8.74264 15.2574 9.75 16.5 9.75C17.7426 9.75 18.75 8.74264 18.75 7.5C18.75 8.74264 19.7574 9.75 21 9.75C22.2426 9.75 23.25 8.74264 23.25 7.5L21.88 1.337C21.804 0.993808 21.4995 0.749658 21.148 0.75Z",
  stroke: "white",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));
var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_245_839"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white"
})));
var SvgCorporateSalesManagerIcon = function SvgCorporateSalesManagerIcon(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCorporateSalesManagerIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/corporate-sales-manager-icon.ed81a844.svg";
export { ForwardRef as ReactComponent };